import routes from '../../config/routes';

const buildShowroomPageUrl = (slug: string) => {
  return `${routes.showrooms}/${slug}`;
};

export default buildShowroomPageUrl;
